import React from 'react'
import { observer } from 'mobx-react-lite'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'

type FormControlLabelProps = React.ComponentProps<typeof FormControlLabel>
type CheckboxProps = React.ComponentProps<typeof Checkbox>

interface CheckBoxWithLabelProps
   extends Pick<FormControlLabelProps, 'label' | 'className'>,
   CheckboxProps {
   error?: boolean
   helperText?: string
   title?: string,
   resetIndent?: boolean,
   /** @default 'center' */
   align?: 'center' | 'first-line'
}

export const CheckBoxWithLabel = observer(function CheckBoxWithLabel
   ({ label, className, helperText, error, title, resetIndent, align, ...props }: CheckBoxWithLabelProps) {
   return (
      <>
         <FormControlLabel
            label={label}
            className={className}
            control={
               <Checkbox
                  inputProps={{
                     'aria-label': typeof label === 'string' ? label : undefined,
                     title: title,
                  }}
                  {...props}
               />
            }
            sx={[
               ...(align === 'first-line' ? [{
                  alignItems: 'flex-start',

                  '> .MuiTypography-root': {
                     marginTop: '10px',
                  }
               }] : []),
               ...(resetIndent ? [{
                  marginLeft: 0,
               }] : [])
            ]}
         />
         {helperText ? <FormHelperText error={error}>{helperText}</FormHelperText> : null}
      </>
   );
}
)
